import createMuiTheme from '@material-ui/core/styles/createMuiTheme';

const lightTheme = createMuiTheme({
  breakpoints: { values: { xs: 0, sm: 576, md: 768, lg: 992, xl: 1200 } },
  palette: {
    primary: { main: '#172154' },
    secondary: { main: '#6B1544' },
  },
  typography: {
    useNextVariants: true,
    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
  },
});

const darkTheme = createMuiTheme({
  breakpoints: { values: { xs: 0, sm: 576, md: 768, lg: 992, xl: 1200 } },
  palette: {
    type: 'dark',
    primary: { main: '#172154' },
    secondary: { main: '#6B1544' },
  },
  typography: {
    useNextVariants: true,
    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
  },
});

export { lightTheme, darkTheme };



// WEBPACK FOOTER //
// ./src/themes.js